// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-results {
  background-color: #e4e6eb;
}

.row-navbar {
  margin-top: 2rem;
}

.quickAccess-results {
  height: 100vh;
  padding-left: 0px !important;
}

.list-group {
  margin: 0px 25px 0px 0px;
  border-radius: 1rem !important;
}

.data-search {
  background-color: #ffffff !important;
  border-bottom: 2px solid #cccccc;
  height: 10rem;
  margin-top: 1rem;
  margin-left: 1rem;
  border-radius: 12px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.data-search h5 {
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-weight: 600;
  font-size: 20px/30px;
  letter-spacing: 0px;
  color: #151515;
  opacity: 1;
  margin: 1rem;
}
.data-search p {
  text-align: left;
  font-size: 14px/24px;
  font-family: "Lato", sans-serif !important;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
  padding: 0rem 1rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.data-search .list-group-item {
  border: none;
  padding: 0;
  margin: 0;
  border-radius: 2rem !important;
}

.no-results {
  margin: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  border: 1px solid #cccccc;
  border-radius: 20px;
}
.no-results .col {
  text-align: center;
  font-family: "Lato", sans-serif !important;
  font-size: 20px/30px;
  font-weight: 600;
  letter-spacing: 0px;
  opacity: 1;
}
.no-results .col h3 {
  color: #b8b8b8;
}
.no-results .col p {
  color: #615e5e !important;
}

@media (max-width: 576px) {
  .data-search h5 {
    text-align: left;
    font-family: "Lato", sans-serif !important;
    font-weight: 600;
    font-size: 15px;
    letter-spacing: 0px;
    color: #151515;
    opacity: 1;
    margin: 20px 20px 10px 20px;
  }
  .data-search p {
    text-align: left;
    font-size: 12px;
    font-family: "Lato", sans-serif !important;
    letter-spacing: 0px;
    color: #1a1919;
    opacity: 1;
    padding: 0rem 20px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.no-results-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
}
.no-results-dialog h3 {
  margin-bottom: 0.1em;
}`, "",{"version":3,"sources":["webpack://./src/sass/layout/searchResults/searchResults.scss","webpack://./src/sass/layout/searchResults/searchResults.css","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAGA;EACE,yBAAA;ACFF;;ADIA;EACE,gBAAA;ACDF;;ADGA;EACE,aAAA;EAEA,4BAAA;ACDF;;ADGA;EACE,wBAAA;EACA,8BAAA;ACAF;;ADEA;EACE,oCAAA;EACA,gCAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;ACCF;ADAE;EACE,gBAAA;EACA,0CE3BG;EF4BH,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;ACEJ;ADAE;EACE,gBAAA;EACA,oBAAA;EACA,0CEtCG;EFuCH,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;ACEJ;ADAE;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,8BAAA;ACEJ;;ADCA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;ACEF;ADDE;EACE,kBAAA;EACA,0CElEG;EFmEH,oBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,UAAA;ACEJ;ADDI;EACE,cAAA;ACGN;ADDI;EACE,yBAAA;ACGN;;ADOA;EACE;IACE,gBAAA;IACA,0CEzFG;IF0FH,gBAAA;IACA,eAAA;IACA,mBAAA;IACA,cAAA;IACA,UAAA;IACA,2BAAA;ECJF;EDMA;IACE,gBAAA;IACA,eAAA;IACA,0CEpGG;IFqGH,mBAAA;IACA,cAAA;IACA,UAAA;IACA,kBAAA;IACA,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;IACA,uBAAA;ECJF;AACF;ADOA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;ACLF;ADOE;EACE,oBAAA;ACLJ","sourcesContent":["@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n\n.container-results {\n  background-color: #e4e6eb;\n}\n.row-navbar {\n  margin-top: 2rem;\n}\n.quickAccess-results {\n  height: 100vh;\n\n  padding-left: 0px !important;\n}\n.list-group {\n  margin: 0px 25px 0px 0px;\n  border-radius: 1rem !important;\n}\n.data-search {\n  background-color: #ffffff !important;\n  border-bottom: 2px solid #cccccc;\n  height: 10rem;\n  margin-top: 1rem;\n  margin-left: 1rem;\n  border-radius: 12px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  h5 {\n    text-align: left;\n    font-family: $Font;\n    font-weight: 600;\n    font-size: 20px/30px;\n    letter-spacing: 0px;\n    color: #151515;\n    opacity: 1;\n    margin: 1rem;\n  }\n  p {\n    text-align: left;\n    font-size: 14px/24px;\n    font-family: $Font;\n    letter-spacing: 0px;\n    color: #1a1919;\n    opacity: 1;\n    padding: 0rem 1rem;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  .list-group-item {\n    border: none;\n    padding: 0;\n    margin: 0;\n    border-radius: 2rem !important;\n  }\n}\n.no-results {\n  margin: 1em;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80vh;\n  border: 1px solid #cccccc;\n  border-radius: 20px;\n  .col {\n    text-align: center;\n    font-family: $Font;\n    font-size: 20px/30px;\n    font-weight: 600;\n    letter-spacing: 0px;\n\n    opacity: 1;\n    h3 {\n      color: #b8b8b8;\n    }\n    p {\n      color: #615e5e !important;\n    }\n  }\n}\n// .search-icon {\n//   position: relative;\n//   right: 16.5rem;\n//   top: 2rem;\n// }\n\n@media (max-width: 576px) {\n  .data-search h5 {\n    text-align: left;\n    font-family: $Font;\n    font-weight: 600;\n    font-size: 15px;\n    letter-spacing: 0px;\n    color: #151515;\n    opacity: 1;\n    margin: 20px 20px 10px 20px;\n  }\n  .data-search p {\n    text-align: left;\n    font-size: 12px;\n    font-family: $Font;\n    letter-spacing: 0px;\n    color: #1a1919;\n    opacity: 1;\n    padding: 0rem 20px;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.no-results-dialog {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1em;\n  \n  h3 {\n    margin-bottom: 0.1em;\n  }\n}",".container-results {\n  background-color: #e4e6eb;\n}\n\n.row-navbar {\n  margin-top: 2rem;\n}\n\n.quickAccess-results {\n  height: 100vh;\n  padding-left: 0px !important;\n}\n\n.list-group {\n  margin: 0px 25px 0px 0px;\n  border-radius: 1rem !important;\n}\n\n.data-search {\n  background-color: #ffffff !important;\n  border-bottom: 2px solid #cccccc;\n  height: 10rem;\n  margin-top: 1rem;\n  margin-left: 1rem;\n  border-radius: 12px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.data-search h5 {\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  font-weight: 600;\n  font-size: 20px/30px;\n  letter-spacing: 0px;\n  color: #151515;\n  opacity: 1;\n  margin: 1rem;\n}\n.data-search p {\n  text-align: left;\n  font-size: 14px/24px;\n  font-family: \"Lato\", sans-serif !important;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n  padding: 0rem 1rem;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.data-search .list-group-item {\n  border: none;\n  padding: 0;\n  margin: 0;\n  border-radius: 2rem !important;\n}\n\n.no-results {\n  margin: 1em;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80vh;\n  border: 1px solid #cccccc;\n  border-radius: 20px;\n}\n.no-results .col {\n  text-align: center;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 20px/30px;\n  font-weight: 600;\n  letter-spacing: 0px;\n  opacity: 1;\n}\n.no-results .col h3 {\n  color: #b8b8b8;\n}\n.no-results .col p {\n  color: #615e5e !important;\n}\n\n@media (max-width: 576px) {\n  .data-search h5 {\n    text-align: left;\n    font-family: \"Lato\", sans-serif !important;\n    font-weight: 600;\n    font-size: 15px;\n    letter-spacing: 0px;\n    color: #151515;\n    opacity: 1;\n    margin: 20px 20px 10px 20px;\n  }\n  .data-search p {\n    text-align: left;\n    font-size: 12px;\n    font-family: \"Lato\", sans-serif !important;\n    letter-spacing: 0px;\n    color: #1a1919;\n    opacity: 1;\n    padding: 0rem 20px;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n.no-results-dialog {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1em;\n}\n.no-results-dialog h3 {\n  margin-bottom: 0.1em;\n}/*# sourceMappingURL=searchResults.css.map */","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
